import React, { useEffect, useState, useContext, useRef } from "react";
import { getRawMaterials, getUnits, get_rawtransaction, get_raw_material_stock_report } from "../../../../Utility/Api";
import { useNavigate } from "react-router-dom";
import { NaviGate, shop_id } from "../../../../Utility/function";
import { WarehouseContext } from "../../../../Utility/UserContext";
import "./../table.css";
import * as XLSX from "xlsx";

const RawMaterialReport = () => {
    const navigate = useNavigate();
    const { showLoader, hideLoader, shopItem } = useContext(WarehouseContext);
    const [rawMaterials, setRawMaterials] = useState([]);
    const [unitsList, setUnitsList] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [selectedType, setSelectedType] = useState("");
    const [stockStatus, setStockStatus] = useState("");

    const [activeTab, setActiveTab] = useState("current_stock");

    // Stock Summary state - single "as of date"
    const today = new Date().toISOString().split("T")[0];
    const [asOfDate, setAsOfDate] = useState(today);
    const [stockSummary, setStockSummary] = useState([]);
    const [totalClosingCost, setTotalClosingCost] = useState(0);
    const [summaryAsOf, setSummaryAsOf] = useState("");
    const [summaryLoaded, setSummaryLoaded] = useState(false);

    const [companyInfo, setCompanyInfo] = useState({
        name: "ZTR Masala",
        address: "Business Address",
        phone: "",
        email: ""
    });

    useEffect(() => {
        if (shopItem) {
            setCompanyInfo({
                name: shopItem?.title || "ZTR Masala",
                address: shopItem?.Address || "Business Address",
                phone: shopItem?.phone1 || "",
                email: shopItem?.email || ""
            });
        }
    }, [shopItem]);

    useEffect(() => {
        fetchData();
        fetchUnits();
    }, []);

    const fetchData = async () => {
        try {
            showLoader();
            const response = await getRawMaterials();
            const txnResponse = await get_rawtransaction("", 100000, "", "1");

            const totalsMap = {};
            if (txnResponse.data && txnResponse.data.data) {
                txnResponse.data.data.forEach(t => {
                    const rawId = String(t.raw_mat_id);
                    if (!totalsMap[rawId]) {
                        totalsMap[rawId] = { total_qty: 0, total_price: 0 };
                    }
                    totalsMap[rawId].total_qty += parseFloat(t.qty || 0);
                    totalsMap[rawId].total_price += parseFloat(t.price || 0);
                });
            }

            if (response.data && response.data.data) {
                const enriched = response.data.data.map(item => {
                    const totals = totalsMap[String(item.id)] || { total_qty: 0, total_price: 0 };
                    return { ...item, total_qty: totals.total_qty, total_price: totals.total_price };
                });
                setRawMaterials(enriched);
            }
            hideLoader();
        } catch (error) {
            hideLoader();
            console.error("Error fetching raw materials data:", error);
        }
    };

    const fetchSummaryData = async () => {
        if (!asOfDate) {
            alert("Please select a date");
            return;
        }
        try {
            showLoader();
            setSummaryLoaded(false);
            const response = await get_raw_material_stock_report({
                to_date: asOfDate,
                shop_id: shopItem?.id
            });
            if (response.data && response.data.status === "success") {
                setStockSummary(response.data.data || []);
                setTotalClosingCost(response.data.total_closing_cost || 0);
                setSummaryAsOf(response.data.as_of_date || asOfDate);
                setSummaryLoaded(true);
            }
            hideLoader();
        } catch (error) {
            hideLoader();
            console.error("Error fetching summary:", error);
        }
    };

    const fetchUnits = async () => {
        try {
            const response = await getUnits();
            if (response.data && response.data.data) {
                setUnitsList(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching units:", error);
        }
    };

    const getUnitName = (unitId) => {
        if (!unitId) return "";
        const found = unitsList.find(u => String(u.id) === String(unitId));
        if (found) return found.title;
        if (String(unitId) === "1") return "kg";
        if (String(unitId) === "2") return "gram";
        return unitId;
    };

    const applyFilters = () => {
        let filtered = [...rawMaterials];
        if (selectedType) {
            filtered = filtered.filter(item => String(item.type) === String(selectedType));
        }
        if (stockStatus === "low") {
            filtered = filtered.filter(item => {
                const stock = parseFloat(item.remaining_stock || 0);
                const reorder = parseFloat(item.reorder_point || 0);
                return stock <= reorder;
            });
        } else if (stockStatus === "instock") {
            filtered = filtered.filter(item => {
                const stock = parseFloat(item.remaining_stock || 0);
                const reorder = parseFloat(item.reorder_point || 0);
                return stock > reorder;
            });
        }
        if (searchText) {
            const search = searchText.toLowerCase();
            filtered = filtered.filter(item =>
                (item.title && item.title.toLowerCase().includes(search)) ||
                (item.product_code && item.product_code.toLowerCase().includes(search))
            );
        }
        return filtered;
    };

    // Summary search filter
    const [summarySearch, setSummarySearch] = useState("");
    const filteredSummary = stockSummary.filter(item =>
        !summarySearch || item.product_title?.toLowerCase().includes(summarySearch.toLowerCase())
    );

    const filteredData = applyFilters();
    const totalMaterials = activeTab === "current_stock" ? filteredData.length : filteredSummary.length;
    const lowStockCount = filteredData.filter(item =>
        parseFloat(item.remaining_stock || 0) <= parseFloat(item.reorder_point || 0)
    ).length;

    const handlePrint = () => {
        const printWindow = window.open("", "_blank");
        const printContent = document.getElementById("printable-raw-material-report").innerHTML;
        printWindow.document.write(`
            <!DOCTYPE html>
            <html>
            <head>
                <title>Raw Material Stock Report</title>
                <style>
                    @media print {
                        @page { size: A4 portrait; margin: 0.5in; }
                        body { font-family: Arial, sans-serif; font-size: 12pt; color: #000; background: #fff; }
                        .print-container { width: 100%; max-width: 21cm; margin: 0 auto; }
                        .print-header { text-align: center; margin-bottom: 20px; border-bottom: 2px solid #000; padding-bottom: 15px; }
                        .print-header h1 { font-size: 20pt; margin: 0; }
                        .print-header p { margin: 5px 0; font-size: 11pt; }
                        .report-table { width: 100%; border-collapse: collapse; margin: 15px 0; font-size: 10pt; }
                        .report-table th, .report-table td { border: 1px solid #ddd; padding: 8px; text-align: left; }
                        .report-table th { background-color: #f2f2f2; font-weight: bold; }
                        .text-right { text-align: right; }
                        .total-row td { font-weight: bold; background: #f8f9fa; }
                        .footer { margin-top: 30px; text-align: center; font-size: 10pt; color: #6c757d; }
                    }
                </style>
            </head>
            <body>
                ${printContent}
                <script>
                    window.onload = function() { window.print(); setTimeout(function() { window.close(); }, 100); };
                </script>
            </body>
            </html>
        `);
        printWindow.document.close();
    };

    const exportSummaryToExcel = () => {
        const exportData = filteredSummary.map((item, index) => ({
            "S.No": index + 1,
            "Product Name": item.product_title,
            "Closing Stock": item.closing_stock,
            "Price/Unit (INR)": item.price_unit,
            "Closing Cost (INR)": item.closing_cost
        }));
        exportData.push({
            "S.No": "",
            "Product Name": "TOTAL",
            "Closing Stock": "",
            "Price/Unit (INR)": "",
            "Closing Cost (INR)": filteredSummary.reduce((a, i) => a + parseFloat(i.closing_cost || 0), 0).toFixed(2)
        });
        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Closing_Stock");
        XLSX.writeFile(wb, `Closing_Stock_${summaryAsOf || asOfDate}.xlsx`);
    };

    return (
        <div className="page-content py-1">
            <NaviGate />
            <div className="card p-3 mx-2 overflow-y-scroll" style={{ minHeight: "90vh" }}>

                {/* Tabs */}
                <div className="d-flex justify-content-center mb-4">
                    <div className="btn-group shadow-sm" role="group">
                        <button
                            type="button"
                            className={`btn ${activeTab === "current_stock" ? "btn-primary" : "btn-outline-primary"} px-4 py-2`}
                            onClick={() => setActiveTab("current_stock")}
                        >
                            Current Stock
                        </button>
                        <button
                            type="button"
                            className={`btn ${activeTab === "stock_summary" ? "btn-primary" : "btn-outline-primary"} px-4 py-2`}
                            onClick={() => setActiveTab("stock_summary")}
                        >
                            Closing Stock (By Date)
                        </button>
                    </div>
                </div>

                {/* Header bar */}
                <div className="d-flex mb-4 border-bottom justify-content-between align-items-center flex-wrap pb-3" style={{ width: "100%" }}>
                    <h5 className="text-start w-auto fw-bold mb-0 text-uppercase">
                        {activeTab === "stock_summary" ? "Raw Material — Closing Stock Report" : "Raw Material Report"}
                    </h5>
                    <div className="d-flex gap-2 align-items-center flex-wrap ms-auto">

                        {activeTab === "stock_summary" && (
                            <>
                                {/* Single "As of Date" picker */}
                                <div style={{ width: "180px" }}>
                                    <div className="form-floating">
                                        <input
                                            type="date"
                                            id="asOfDate"
                                            className="form-control"
                                            value={asOfDate}
                                            onChange={(e) => setAsOfDate(e.target.value)}
                                        />
                                        <label htmlFor="asOfDate">As of Date</label>
                                    </div>
                                </div>
                                <button
                                    type="button"
                                    className="btn btn-primary p-3"
                                    onClick={fetchSummaryData}
                                    style={{ height: "58px" }}
                                >
                                    Filter
                                </button>
                                {summaryLoaded && (
                                    <div style={{ width: "200px" }}>
                                        <div className="form-floating">
                                            <input
                                                className="form-control"
                                                value={summarySearch}
                                                onChange={(e) => setSummarySearch(e.target.value)}
                                                placeholder="Search"
                                                id="summarySearch"
                                            />
                                            <label htmlFor="summarySearch">Search Product</label>
                                        </div>
                                    </div>
                                )}
                                {summaryLoaded && (
                                    <button
                                        type="button"
                                        className="btn btn-success p-3"
                                        onClick={exportSummaryToExcel}
                                        style={{ height: "58px" }}
                                    >
                                        <i className="bi bi-file-earmark-excel me-1"></i> Export
                                    </button>
                                )}
                            </>
                        )}

                        {activeTab === "current_stock" && (
                            <>
                                <div style={{ width: "220px" }}>
                                    <div className="form-floating">
                                        <input
                                            className="form-control"
                                            value={searchText}
                                            onChange={(e) => setSearchText(e.target.value)}
                                            placeholder="Search"
                                            id="searchMaterial"
                                        />
                                        <label htmlFor="searchMaterial">Search Material/Code</label>
                                    </div>
                                </div>
                                <div style={{ width: "160px" }}>
                                    <div className="form-floating">
                                        <select
                                            className="form-select"
                                            value={selectedType}
                                            onChange={(e) => setSelectedType(e.target.value)}
                                            id="materialType"
                                        >
                                            <option value="">All Types</option>
                                            <option value="2">Spices</option>
                                            <option value="1">Packaging material</option>
                                        </select>
                                        <label htmlFor="materialType">Material Type</label>
                                    </div>
                                </div>
                                <div style={{ width: "160px" }}>
                                    <div className="form-floating">
                                        <select
                                            className="form-select"
                                            value={stockStatus}
                                            onChange={(e) => setStockStatus(e.target.value)}
                                            id="stockStatusFilter"
                                        >
                                            <option value="">All Stock Status</option>
                                            <option value="low">Low Stock Alert</option>
                                            <option value="instock">In Stock</option>
                                        </select>
                                        <label htmlFor="stockStatusFilter">Stock Status</label>
                                    </div>
                                </div>
                            </>
                        )}

                        <button
                            type="button"
                            className="btn btn-dark p-3"
                            onClick={handlePrint}
                            style={{ height: "58px" }}
                        >
                            <i className="bi bi-printer me-1"></i> Print
                        </button>
                    </div>
                </div>

                {/* Summary info bar */}
                {activeTab === "stock_summary" && summaryLoaded && (
                    <div className="alert alert-info d-flex justify-content-between align-items-center py-2 mb-3">
                        <span>
                            <strong>Closing Stock as of:</strong> {new Date(summaryAsOf + "T00:00:00").toLocaleDateString("en-IN", { day: "2-digit", month: "long", year: "numeric" })}
                            &nbsp;|&nbsp; <strong>Total Items:</strong> {filteredSummary.length}
                        </span>
                        <span className="fs-5 fw-bold text-dark">
                            Total Cost: ₹{filteredSummary.reduce((a, i) => a + parseFloat(i.closing_cost || 0), 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </span>
                    </div>
                )}

                {activeTab === "current_stock" && (
                    <div className="d-flex justify-content-between mb-3 px-2">
                        <div><strong>Total Items:</strong> {totalMaterials}</div>
                        <div>
                            <strong>Low Stock Alerts:</strong>{" "}
                            <span className={lowStockCount > 0 ? "text-danger fw-bold" : "text-success"}>{lowStockCount}</span>
                        </div>
                    </div>
                )}

                {/* Tables */}
                <div className="table-responsive text-center my-2 w-100 position-relative">

                    {activeTab === "stock_summary" ? (
                        !summaryLoaded ? (
                            <div className="text-center py-5 text-muted">
                                <i className="bi bi-calendar-date fs-1 d-block mb-3 text-primary opacity-50"></i>
                                <h6>Select a date and click <strong>Filter</strong> to view closing stock</h6>
                                <p className="small">This report shows remaining raw material quantities and their total cost as of the selected date.</p>
                            </div>
                        ) : (
                            <table className="table table-sm table-bordered table-hover">
                                <thead className="table-dark">
                                    <tr>
                                        <th style={{ width: "50px" }}>S.No</th>
                                        <th className="text-start">Product Name</th>
                                        <th>Remaining Stock</th>
                                        <th>Price / Unit (INR)</th>
                                        <th>Closing Cost (INR)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredSummary.length > 0 ? (
                                        filteredSummary.map((item, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td className="fw-semibold text-start px-3">{item.product_title || "-"}</td>
                                                <td className="text-primary fw-bold">
                                                    {parseFloat(item.closing_stock).toFixed(3)} kg
                                                </td>
                                                <td className="text-muted">
                                                    ₹{parseFloat(item.price_unit || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                </td>
                                                <td className="fw-bold text-dark">
                                                    ₹{parseFloat(item.closing_cost || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="5" className="text-center py-4 text-muted">
                                                No stock found for the selected date.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                                {filteredSummary.length > 0 && (
                                    <tfoot>
                                        <tr className="table-dark">
                                            <th colSpan="4" className="text-end px-3">
                                                Total Closing Cost (Raw Materials):
                                            </th>
                                            <th className="text-start fw-bold fs-6">
                                                ₹{filteredSummary.reduce((acc, item) => acc + parseFloat(item.closing_cost || 0), 0)
                                                    .toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                            </th>
                                        </tr>
                                    </tfoot>
                                )}
                            </table>
                        )
                    ) : (
                        <table className="table table-sm table-bordered table-hover">
                            <thead className="table-dark">
                                <tr>
                                    <th>S.No</th>
                                    <th>Title</th>
                                    <th>Type</th>
                                    <th>Product Code</th>
                                    <th>Reorder Point</th>
                                    <th>Latest Price (INR)</th>
                                    <th>Total Quantity</th>
                                    <th>Total Price (INR)</th>
                                    <th>Stocks Available</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredData.length > 0 ? (
                                    filteredData.map((item, index) => {
                                        const stock = parseFloat(item.remaining_stock || 0);
                                        const totalQty = parseFloat(item.total_qty || 0);
                                        const totalPrice = parseFloat(item.total_price || 0);
                                        const reorder = parseFloat(item.reorder_point || 0);
                                        const isLowStock = stock <= reorder;

                                        return (
                                            <tr key={item.id} className={isLowStock ? "table-warning" : ""}>
                                                <td>{index + 1}</td>
                                                <td className="fw-semibold">{item.title}</td>
                                                <td>{String(item.type) === "1" ? "Packaging material" : "Spices"}</td>
                                                <td>{item.product_code || "N/A"}</td>
                                                <td>{item.reorder_point || 0}</td>
                                                <td>{parseFloat(item.latest_price_unit || 0).toFixed(2)}</td>
                                                <td>{totalQty.toFixed(2)} {getUnitName(item.unit_id)}</td>
                                                <td>{totalPrice.toFixed(2)}</td>
                                                <td>
                                                    <span className={isLowStock ? "text-danger fw-bold" : ""}>
                                                        {stock.toFixed(2)} {getUnitName(item.unit_id)}
                                                        {isLowStock && (
                                                            <span className="ms-1 badge bg-danger text-white">Low Stock</span>
                                                        )}
                                                    </span>
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="9" className="text-center py-4 text-muted">
                                            No raw materials found.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    )}
                </div>

                {/* Printable area (hidden) */}
                <div id="printable-raw-material-report" style={{ display: "none" }}>
                    <div className="print-container">
                        <div className="print-header">
                            <h1>{companyInfo.name}</h1>
                            <p>{companyInfo.address}</p>
                            <p>Phone: {companyInfo.phone} | Email: {companyInfo.email}</p>
                            <h2 style={{ marginTop: "20px", textTransform: "uppercase" }}>
                                {activeTab === "stock_summary" ? `Raw Material Closing Stock — As of ${summaryAsOf}` : "Raw Material Stock Report"}
                            </h2>
                        </div>

                        <div className="report-info" style={{ display: "flex", justifyContent: "space-between", margin: "15px 0", padding: "10px", background: "#f8f9fa" }}>
                            <div>
                                <strong>Generated On:</strong> {new Date().toLocaleDateString()} at {new Date().toLocaleTimeString()}
                            </div>
                            <div>
                                <strong>Total Items:</strong> {totalMaterials}
                                {activeTab === "stock_summary" && summaryLoaded && (
                                    <> | <strong>Total Cost: ₹{totalClosingCost.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</strong></>
                                )}
                            </div>
                        </div>

                        {activeTab === "stock_summary" && summaryLoaded ? (
                            <table className="report-table" style={{ width: "100%", borderCollapse: "collapse" }}>
                                <thead>
                                    <tr>
                                        <th style={{ border: "1px solid #ddd", padding: "8px", background: "#f2f2f2" }}>S.No</th>
                                        <th style={{ border: "1px solid #ddd", padding: "8px", background: "#f2f2f2" }}>Product Name</th>
                                        <th style={{ border: "1px solid #ddd", padding: "8px", background: "#f2f2f2" }}>Remaining Stock</th>
                                        <th style={{ border: "1px solid #ddd", padding: "8px", background: "#f2f2f2" }}>Price/Unit (₹)</th>
                                        <th style={{ border: "1px solid #ddd", padding: "8px", background: "#f2f2f2" }}>Closing Cost (₹)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredSummary.map((item, index) => (
                                        <tr key={index}>
                                            <td style={{ border: "1px solid #ddd", padding: "8px" }}>{index + 1}</td>
                                            <td style={{ border: "1px solid #ddd", padding: "8px", fontWeight: "bold" }}>{item.product_title}</td>
                                            <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "right" }}>{parseFloat(item.closing_stock).toFixed(3)} kg</td>
                                            <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "right" }}>₹{parseFloat(item.price_unit || 0).toFixed(2)}</td>
                                            <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "right", fontWeight: "bold" }}>
                                                ₹{parseFloat(item.closing_cost || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                            </td>
                                        </tr>
                                    ))}
                                    <tr style={{ fontWeight: "bold", background: "#f2f2f2" }}>
                                        <td colSpan="4" style={{ border: "1px solid #ddd", padding: "8px", textAlign: "right" }}>
                                            Total Closing Cost:
                                        </td>
                                        <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "right" }}>
                                            ₹{filteredSummary.reduce((a, i) => a + parseFloat(i.closing_cost || 0), 0)
                                                .toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        ) : (
                            <table className="report-table" style={{ width: "100%", borderCollapse: "collapse" }}>
                                <thead>
                                    <tr>
                                        {["S.No", "Title", "Type", "Product Code", "Reorder Point", "Latest Price (INR)", "Total Qty", "Total Price (INR)", "Stock Available"].map(h => (
                                            <th key={h} style={{ border: "1px solid #ddd", padding: "8px", background: "#f2f2f2" }}>{h}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredData.map((item, index) => {
                                        const stock = parseFloat(item.remaining_stock || 0);
                                        const reorder = parseFloat(item.reorder_point || 0);
                                        const isLowStock = stock <= reorder;
                                        return (
                                            <tr key={item.id}>
                                                <td style={{ border: "1px solid #ddd", padding: "8px" }}>{index + 1}</td>
                                                <td style={{ border: "1px solid #ddd", padding: "8px", fontWeight: "bold" }}>{item.title}</td>
                                                <td style={{ border: "1px solid #ddd", padding: "8px" }}>{String(item.type) === "1" ? "Packaging" : "Spices"}</td>
                                                <td style={{ border: "1px solid #ddd", padding: "8px" }}>{item.product_code || "N/A"}</td>
                                                <td style={{ border: "1px solid #ddd", padding: "8px" }}>{item.reorder_point || 0}</td>
                                                <td style={{ border: "1px solid #ddd", padding: "8px" }}>{parseFloat(item.latest_price_unit || 0).toFixed(2)}</td>
                                                <td style={{ border: "1px solid #ddd", padding: "8px" }}>{parseFloat(item.total_qty || 0).toFixed(2)} {getUnitName(item.unit_id)}</td>
                                                <td style={{ border: "1px solid #ddd", padding: "8px" }}>{parseFloat(item.total_price || 0).toFixed(2)}</td>
                                                <td style={{ border: "1px solid #ddd", padding: "8px", color: isLowStock ? "#cc0000" : "#000", fontWeight: isLowStock ? "bold" : "normal" }}>
                                                    {stock.toFixed(2)} {getUnitName(item.unit_id)}{isLowStock && " (LOW)"}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        )}

                        <div className="footer" style={{ marginTop: "30px", textAlign: "center", fontSize: "10pt", color: "#6c757d" }}>
                            <p>ZTR Masala Inventory Management System</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RawMaterialReport;
